'use strict';

import controller from './controller';
import callOrderController from './callOrderController';
import filterListController from './filterListController';
import service from './service';
import userListContainerDirective from './user-list/container';
import userListSaveDirective from './user-list/save';
import userListAddUserDirective from './user-list/add-user';

const MODULE_NAME = 'daupler.entities.generic';

var app = angular.module(MODULE_NAME, []);
app.controller('EntityCtrl', controller);
app.controller('CallOrderCtrl', callOrderController);
app.controller('FilterListCtrl', filterListController);
app.factory('entityService', service);
app.directive('userListContainer', userListContainerDirective);
app.directive('userListSave', userListSaveDirective);
app.directive('userListAddUser', userListAddUserDirective);

export default MODULE_NAME;
